import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocationScope } from '../context/LocationContext';

export const LOCATION_ROUTES = new Set([
  '/',
  '/ingresos',
  '/gastos',
  '/analisis',
  '/resultados',
  '/tesoreria',
  '/inversiones',
  '/objetivos',
  '/impuestos',
  '/asistente',
]);
/**
 * Donde tiene sentido «Todos los locales». Impuestos no: la periodificacion
 * CREA gastos, y cada uno tiene que caer en un local concreto (7 sep 2026).
 */
const CONSOLIDATED_ROUTES = new Set(['/', '/analisis', '/resultados', '/tesoreria', '/objetivos', '/asistente']);

/** Selector global de local. "Todos" activa las consultas consolidadas. */
export function LocationPicker(): JSX.Element | null {
  const { locations, locationId, setLocationId } = useLocationScope();
  const route = useLocation();
  const relevant = LOCATION_ROUTES.has(route.pathname);
  const allowConsolidated = CONSOLIDATED_ROUTES.has(route.pathname);

  useEffect(() => {
    // Las pantallas operativas editan registros concretos. Al entrar desde
    // una vista consolidada se elige un centro real para evitar, por ejemplo,
    // mezclar dos cierres del mismo día en la rejilla de ingresos.
    if (relevant && !allowConsolidated && !locationId && locations[0]) {
      setLocationId(locations[0].locationId);
    }
  }, [allowConsolidated, locationId, locations, relevant, setLocationId]);

  if (!relevant || locations.length <= 1) return null;
  return (
    <label className="location-picker" data-tour="local">
      <span>Local</span>
      <select
        aria-label="Local"
        value={locationId ?? 'all'}
        onChange={(event) => setLocationId(event.target.value === 'all' ? undefined : event.target.value)}
      >
        {allowConsolidated && <option value="all">Todos los locales</option>}
        {locations.map((location) => (
          <option key={location.locationId} value={location.locationId}>
            {location.name}
          </option>
        ))}
      </select>
    </label>
  );
}
